import { render } from "./wfhDashboard.vue?vue&type=template&id=2d81b6f2&scoped=true"
import script from "./wfhDashboard.vue?vue&type=script&lang=js"
export * from "./wfhDashboard.vue?vue&type=script&lang=js"

import "./wfhDashboard.vue?vue&type=style&index=0&id=2d81b6f2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/Portal/portal-partner-cicd-staging@2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d81b6f2"]])

export default __exports__